import React, { useState, useEffect } from "react";
import TaskItem from "./TaskItem";
import AddTaskComponent from "./AddTaskComponent"; 
import EditTaskModal from "./EditTaskModal";
import api from '../../api/api';

const MyTasksCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [tasksData, setTasksData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTasks = async () => {
    try {
      const res = await api.get('/tasks/?role=assigned');
      setTasksData(res.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(fetchTasks, 10000);
    return () => clearInterval(intervalId);
  }, []);

  const handleEditTask = (task) => {
    setEditingTask(task);
    setIsEditModalOpen(true);
  };

  const handleSaveTask = async (updatedTask) => {
    try {
      await api.put(`/tasks/${updatedTask.id}/`, updatedTask);
      setTasksData(tasksData.map(t => t.id === updatedTask.id ? updatedTask : t));
      setEditingTask(null);
    } catch (error) {
      console.error('Error updating task:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('آیا از حذف این کار مطمئن هستید؟')) {
      try {
        await api.delete(`/tasks/${id}/`);
        setTasksData(tasksData.filter(t => t.id !== id));
      } catch (error) {
        console.error('Error deleting task:', error);
      }
    }
  };

  if (loading) return <div className="p-4 text-center">در حال بارگذاری...</div>;

  return (
    <div className="bg-white w-full max-w-full p-6 rounded-3xl border border-slate-100 shadow-xl flex flex-col h-full overflow-hidden ring-2 ring-blue-500/50 shadow-[0_0_25px_rgba(15,23,42,0.22)] duration-300 hover:shadow-[0_0_35px_rgba(15,23,42,0.35)]" dir="rtl">
      
      <div className="flex justify-between items-center mb-4 flex-shrink-0">
        <h3 className="text-base font-bold text-slate-800">کارهای من</h3>
        <div className="flex items-center gap-2">
          <button onClick={() => setIsModalOpen(true)} className="text-gray-400 hover:text-indigo-600 text-2xl transition-colors">＋</button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="flex flex-col">
          {tasksData.map((task) => (
            <TaskItem key={task.id} task={task} onEdit={handleEditTask} onDelete={handleDelete} />
          ))}
        </div>
      </div>

      {isModalOpen && <AddTaskComponent onClose={() => { setIsModalOpen(false); fetchTasks(); }} forcedAssignee="خودم" />}
      <EditTaskModal isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} task={editingTask} onSave={handleSaveTask} />
    </div>
  );
};

export default MyTasksCard;